<template>
  <div class="tradingview-widget-containers">
    <div class="tradingview-widget-container__widget"></div>
    <div class="tradingview-widget-copyright"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    let container2 = document.getElementsByClassName(
      "tradingview-widget-containers"
    )[0];
    // container2.replaceChildren();
    const script2 = document.createElement("script");
    script2.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-hotlists.js";
    script2.type = "text/javascript";
    script2.async = true;
    script2.innerHTML = JSON.stringify({
      colorTheme: "light",
      dateRange: "12M",
      exchange: "BSE",
      showChart: true,
      locale: "in",
      largeChartUrl: "",
      isTransparent: false,
      showSymbolLogo: false,
      showFloatingTooltip: true,
      width: "100%",
      height: "600",
      plotLineColorGrowing: "rgba(41, 98, 255, 1)",
      plotLineColorFalling: "rgba(41, 98, 255, 1)",
      gridLineColor: "rgba(240, 243, 250, 0)",
      scaleFontColor: "rgba(106, 109, 120, 1)",
      belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
      belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
      belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
      belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
      symbolActiveColor: "rgba(41, 98, 255, 0.12)",
    });
    container2.appendChild(script2);
  },
};
</script>

<style lang="scss" scoped></style>
